import { GraficoBarra } from '@monorepo-web/components-library';
import { FormatTypes } from '@monorepo-web/utils';
export const getLayouts = (theme) => ({
    'default': {},
    'custodiante_monetary': {},
    'legenda_lateral': {
        height: 400,
        FormatTypeParam: FormatTypes.percentage,
        isLegendHorizontal: true,
        outerRadius: '85%',
        innerRadius: '60%',
        disableCursor: true,
        legendHeight: '100%',
    },
    'barra': {
        colors: theme === null || theme === void 0 ? void 0 : theme.chartColors,
        isBarHorizontal: true,
        isPercentToggle: true,
        showAnimation: false,
    },
    'carteira_explodida': {
        disableCursor: true
    }
});
export const getLayoutsPDF = (theme, moneyPrefix) => ({
    'default': {},
    'custodiante_monetary': {
        FormatTypes: FormatTypes.monetary_no_space,
        moneyPrefix
    },
    'legenda_lateral': {
        containerWidth: 500,
        containerHeight: 300,
        GraphComponentsProps: {
            outerRadius: "85%",
            innerRadius: "60%",
        }
    },
    'barra': {
        GraphComponent: GraficoBarra,
        containerWidth: 600,
        containerHeight: 600,
        GraphComponentsProps: {
            decimals: 2,
            moneyPrefix,
            colors: theme === null || theme === void 0 ? void 0 : theme.chartColors,
            height: 400,
            isPercentToggle: true,
            isBarHorizontal: true,
            dispatchPDF: true,
            showAnimation: true,
        }
    },
    'carteira_explodida': {
        titleAlign: 'left'
    }
});
